import { styled } from '@mui/system';
import { Box, TableContainer } from '@mui/material';
import { motion } from 'framer-motion';

export const PeopleContainer = styled(Box)(() => ({
  borderRadius: '12px',
  marginTop: '8px',
  display: 'flex',
  width: '100%',
  height: 'calc(100vh - 100px)',
  overflow: 'hidden',
  transition: 'all 0.3s ease-in-out',
}));

export const EmployeeDirectoryContainer = styled(TableContainer)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'left',
  width: '99%',
  height: 'calc(100vh - 100px)',
  padding: theme.spacing(2),
  flex: '1 1 100%',
  transition: 'flex 0.3s ease-in-out',
  backgroundColor: theme.palette.background.default,

  '&.drawer-open': {
    flex: '1 1 calc(100% - 400px)',
  },
}));

export const EmployeeDirectory = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  padding: '16px',
  borderRadius: '1rem',
  overflowY: 'auto',
  backgroundColor: theme.palette.background.paper,
}));

export const TopContainer = styled(Box)(({ theme }) => ({
  justifyContent: 'flex-end',
  display: 'flex',
  width: '100%',
  marginBottom: theme.spacing(2),
}));

export const MainContentPeople = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  borderRadius: theme.spacing(1),
}));

export const AnimatedTabContent = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, ease: 'easeOut' }}
    style={{ display: 'flex', flexDirection: 'column', gap: '.5rem' }}
  >
    {children}
  </motion.div>
);
